<template>
<div v-if="loaded" :class="{'container' : container, 'container-fluid': fluid, 'p-2': !modal}">
    <collapse-transition>
        <div
            class="card mb-0"
            v-show="forumTopics"
        >
            <div class="card-header d-flex" :style="$bgColor(color.primary)">
                <div class="d-flex">
                    <i
                        class="fas fa-search mt-2"
                        :style="{color: color.secondary}"
                        aria-hidden="true"
                    />
                    <input
                        class="bg-transparent form-control form-control-sm ml-3 w-75"
                        :style="{borderBottom: `1.5px solid ${color.secondary}`}"
                        type="text"
                        :placeholder="$t('common.search')"
                        v-model="search"
                    >
                </div>
                <div class="ml-auto">
                    <BaseButton
                        v-if="!user.public"
                        @click="switchScreen('forumNewTopic')"
                        type="success"
                        class="btn-icon-only rounded-circle"
                    >
                        <i class="icon-size mdi mdi-plus"/>
                    </BaseButton>
                    <BaseButton
                        @click="refreshForum"
                        type="info"
                        class="btn-icon-only rounded-circle"
                    >
                        <i class="icon-size mdi mdi-reload"/>
                    </BaseButton>
                    <BaseButton
                        v-if="modal"
                        @click="$emit('close')"
                        type="danger"
                        class="btn-icon-only rounded-circle"
                    >
                        <i class="mdi mdi-close icon-size"/>
                    </BaseButton>
                </div>
            </div>
            <div class="card-body">
                <h1 v-if="!notitle" class="mb-4 text-center">Forum - {{this.name}}</h1>
                <div v-if="topics.length > 0">
                    <ForumTopic
                        v-for="(topic, index) in topics"
                        @topicSelected="goToTopic"
                        :loading="loading"
                        :key="index"
                        :topic="topic"
                    />
                    <LoadingSpinner
                        v-if="scrollLoading"
                    />
                    <BasePagination
                        v-if="this.meta.total > 5 && this.meta.current_page"
                        class="mb-0"
                        :page-count="this.meta.last_page"
                        :value="this.meta.current_page"
                        @input="onChangePage"
                        align="center"
                        type="#525F7F"
                    />
                </div>
                <Empty
                    v-else
                    class="my-6"
                    :color="color"
                    :icon="'mdi mdi-emoticon-sad-outline'"
                >
                    <template #title><h1 class="font-weight-medium mb-0">{{$t('empty.topic_title')}}</h1></template>
                    <template #subtitle><p>{{$t('empty.filter_subtitle')}}</p></template>
                </Empty>
            </div>
        </div>
    </collapse-transition>
    <collapse-transition>
        <div
            class="card mb-0"
            v-show="forumAnswer">
            <div class="card-header d-flex" :style="$bgColor(color.primary)">
                <BaseButton
                    @click="switchScreen('forumAnswer')"
                    :loading="loading.status"
                    type="success"
                    class="btn-icon-only rounded-circle"
                >
                    <i class="mdi mdi-arrow-left icon-size"/>
                </BaseButton>
            </div>
            <div class="card-body">
                <ForumAnswers
                    :moderated="forum.moderated"
                    :color="color"
                    :selectedTopicInfo="selectedTopicInfo"
                />
            </div>
        </div>
    </collapse-transition>
    <collapse-transition>
        <div
            class="card mb-0"
            v-show="forumNewTopic">
            <div class="card-header d-flex" :style="$bgColor(color.primary)">
                <BaseButton
                    @click="switchScreen('forumNewTopic')"
                    :loading="loading.status"
                    type="success"
                    class="btn-icon-only rounded-circle"
                >
                    <i class="mdi mdi-arrow-left icon-size"/>
                </BaseButton>
            </div>
            <div class="card-body">
                <ForumCreateTopic
                    :moderated="forum.moderated"
                    @postCreated="switchScreen('forumNewTopic', true)"
                    :color="color"
                    :id="forum.id"
                />
            </div>
        </div>
    </collapse-transition>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CollapseTransition } from 'vue2-transitions';
import BaseButton from '../argon/components/BaseButton';
import BasePagination from '../argon/components/BasePagination';
import debounce from '../helpers/helpers';

import Empty from './Common/Empty';
import LoadingSpinner from '../components/Common/LoadingSpinner';
import ForumAnswers from '../components/ForumComponents/ForumAnswers';
import ForumCreateTopic from '../components/ForumComponents/ForumCreateTopic';
import ForumTopic from '../components/ForumComponents/ForumTopic';

export default {
    name: 'Forum',

    components: {
        Empty,
        ForumTopic,
        BaseButton,
        ForumAnswers,
        LoadingSpinner,
        ForumCreateTopic,
        CollapseTransition,
        BasePagination,
    },

    props: {
        forum: {
            type: [Object, Number],
            required: true,
        },
        name: String,
        container: Boolean,
        fluid: Boolean,
        notitle: Boolean,
        noloading: Boolean,
        modal: Boolean,
    },
    data() {
        return {
            selectedTopicInfo: {
                title: '',
                forum: [],
            },
            search: '',
            loading: {},
            loaded: false,
            scrollLoading: false,
            forumTopics: true,
            forumAnswer: false,
            forumNewTopic: false,
            topics: [],
            links: {},
            meta: {},
        };
    },


    watch: {
        search: debounce(function (newVal) {
            this.getTopicsSearch(1, newVal);
        }, 500),
        forum: debounce(function (newVal) {
            this.getTopics();
        }, 500),
    },

    computed: {
        ...mapGetters({
            color: 'COLOR',
            user: 'USER',
        }),
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.links = value.links;
                this.meta = value.meta;
                this.topics = value.data;
            },
        },
    },

    methods: {

        // Muda qual componente deve ser mostrado, o parâmetro 'state' diz qual estado irá mudar

        switchScreen(state, reload) {
            if (reload) this.refreshForum();
            this.forumTopics = !this.forumTopics;
            this[state] = !this[state];
        },

        // Vai para o topico selecionado na lista, enviando o id seu id ao componente filho para a request

        goToTopic(id) {
            this.selectedTopicInfo = this.topics.find((topic) => {
                if (topic.id === id) return topic;
            });
            this.forumTopics = !this.forumTopics;
            this.forumAnswer = !this.forumAnswer;
        },

        // Recarrega a lista do forum

        refreshForum() {
            this.topics = [];
            this.search = '';
            this.loaded = false;
            this.getTopics();
        },

        // Busca todos os topicos do forum

        getTopics(page, search) {
            if (!this.scrollLoading && !this.noloading) {
                this.$loading.show();
            }
            return window.axios.get(`/api/app/forum/${this.forum.id}/topics`, {
                params: {
                    page: page || 1,
                    per_page: 5,
                    search,
                },
            })
                .then((res) => {
                    this.data = res.data;
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.loaded = true;
                    this.$loading.close();
                });
        },

        // Busca todos os topicos do forum (usado caso tenha o parâmentro search no scroll infinito (scroll()))

        getTopicsSearch(page, search) {
            if (!this.scrollLoading) {
                this.$loading.show();
            }
            return window.axios.get(`/api/app/forum/${this.forum.id}/topics`, {
                params: {
                    page: page || 1,
                    per_page: 5,
                    search,
                },
            })
                .then((res) => {
                    if (page <= 1) {
                        this.topics = [];
                    }
                    this.topics = res.data.data;
                    this.meta = res.data.meta;
                    this.links = res.data.links;
                })
                .catch(err => console.error(err))
                .finally(() => this.$loading.close());
        },

        onChangePage(page) {
            if (page) {
                this.meta.current_page = page;
                this.getTopics(page);
            }
        },
    },

    mounted() {
        if (this.forum && this.forum.id) {
            this.getTopics();
        }
    },
};
</script>

<style scoped lang="sass">

.icon-size
    font-size: 1.5rem
    top: -5px !important
    padding: 0 !important

.nch--forum-card
    background-color: #f3f3f3
    border-radius: 4px
    -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08)
    box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08)

.bg-transparent
    background-color: transparent !important
    box-shadow: none

input[type=text]
    min-width: 150px !important
    border: none
    border-radius: 0px
    transition: width 0.4s !important

input[type=text]:focus
    width: 200px !important
</style>
